var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3096 9.47009C21.4856 9.47009 23.2496 7.70609 23.2496 5.53009C23.2496 3.35409 21.4856 1.59009 19.3096 1.59009C17.1336 1.59009 15.3696 3.35409 15.3696 5.53009C15.3696 7.70609 17.1336 9.47009 19.3096 9.47009Z",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2096 9.46997C16.5196 9.46997 14.1696 10.83 12.8896 12.86",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.69 10.3402C32.866 10.3402 34.63 8.57621 34.63 6.40021C34.63 4.2242 32.866 2.46021 30.69 2.46021C28.514 2.46021 26.75 4.2242 26.75 6.40021C26.75 8.57621 28.514 10.3402 30.69 10.3402Z",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1299 10.3401C33.4899 10.3401 35.5799 11.4901 36.8499 13.2601",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 19.9801C27.1761 19.9801 28.9401 18.2161 28.9401 16.0401C28.9401 13.8641 27.1761 12.1001 25.0001 12.1001C22.8241 12.1001 21.0601 13.8641 21.0601 16.0401C21.0601 18.2161 22.8241 19.9801 25.0001 19.9801Z",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8699 24.21C30.1099 21.78 27.7699 20 24.9999 20C22.2299 20 19.8999 21.77 19.1299 24.21",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7399 45.7902V44.2402L6.22986 36.4902C5.85986 36.0502 5.55986 35.5602 5.32986 35.0402C5.01986 34.3102 4.85986 33.5302 4.85986 32.7302V26.7702C4.85986 26.5802 4.86986 26.3802 4.89986 26.1902C4.95986 25.7302 5.08986 25.2802 5.28986 24.8702L7.63986 19.9702C7.84986 19.5302 8.36986 19.3502 8.80986 19.5602L9.71986 20.0002C10.8699 20.5502 11.4599 21.8502 11.1099 23.0802L10.1799 26.3902V27.5202",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6197 45.7902V37.9102C20.5297 36.7002 20.2197 35.5202 19.2997 34.6002L12.8597 28.1602C11.8297 27.1302 10.1697 27.1302 9.13969 28.1602C8.10969 29.1902 8.10969 30.8502 9.13969 31.8802L12.6897 35.4302",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 45.7902V44.2402L43.7698 36.4902C44.1398 36.0502 44.4398 35.5602 44.6698 35.0402C44.9798 34.3102 45.1398 33.5302 45.1398 32.7302V26.7702C45.1398 26.5802 45.1298 26.3802 45.0998 26.1902C45.0398 25.7302 44.9098 25.2802 44.7098 24.8702L42.3598 19.9702C42.1498 19.5302 41.6298 19.3502 41.1898 19.5602L40.2798 20.0002C39.1298 20.5502 38.5398 21.8502 38.8898 23.0802L39.8198 26.3902V27.5202",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3799 45.7902V37.9102C29.4699 36.7002 29.7799 35.5202 30.6999 34.6002L37.1399 28.1602C38.1699 27.1302 39.8299 27.1302 40.8599 28.1602C41.8899 29.1902 41.8899 30.8502 40.8599 31.8802L37.3099 35.4302",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.37 46.0601H10.04V48.8901H22.37V46.0601Z",
    fill: "#F05525"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9198 46.0601H27.5898V48.8901H39.9198V46.0601Z",
    fill: "#F05525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTeams);
export default __webpack_public_path__ + "static/media/Support_Teams.db4e225a31d1d69c3ccdad5806fd58ee.svg";
export { ForwardRef as ReactComponent };